import { GetCategoryInput, useGetCategoryQuery } from 'src/graphql/generated/graphql';

const useGetCategory = (input: GetCategoryInput) => {
  const {
    data,
    error: queryError,
    isError,
    isLoading,
  } = useGetCategoryQuery(
    {
      input,
    },
    {
      // disable refetchOnWindowFocus so that data is not refreshed
      // when user leave the page and come back
      refetchOnWindowFocus: false,
    },
  );

  const graphqlError = data?.getCategory?.error;
  const error = graphqlError || queryError;
  const hasError = isError || !!graphqlError;

  const categoryList = data?.getCategory.category ?? [];
  const subcategoryList = data?.getCategory.subcategory ?? [];

  return {
    categoryList,
    subcategoryList,
    error,
    hasError,
    isLoading,
    errorMessage: graphqlError?.errorMessage || (queryError as Error)?.message,
    errorType: graphqlError?.errorType,
  };
};

export default useGetCategory;
